import { render, staticRenderFns } from "./restrict-icon.vue?vue&type=template&id=5e7d0cd7&scoped=true&"
import script from "./restrict-icon.vue?vue&type=script&lang=js&"
export * from "./restrict-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d0cd7",
  null
  
)

export default component.exports